(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /* Aqualumen: keeps "1–24 din 400 de produse" true while infinite scroll adds or prepends pages */
  if (!customElements.get('aq-results-count')) {
    class AqResultsCount extends HTMLElement {
      connectedCallback() {
        this.list = this.closest('results-list') || document.querySelector('results-list');
        if (!this.list) return;
        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.list, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      update() {
        const to = this.querySelector('[data-aq-count-to]');
        const from = this.querySelector('.aq-count__range');
        if (!to || !from || !this.list) return;
        const items = this.list.querySelectorAll('.product-grid__item[data-page]');
        if (!items.length) return;
        const perPage = Number(this.dataset.perPage) || 24;
        const total = Number(this.dataset.total) || 0;
        const pages = Array.from(items, (item) => Number(item.dataset.page) || 1);
        const first = (Math.min(...pages) - 1) * perPage + 1;
        const last = Math.min(first + items.length - 1, total);
        if (to.textContent !== String(last)) to.textContent = String(last);
        const head = from.firstChild;
        if (head && head.nodeType === Node.TEXT_NODE && head.textContent !== `${first}–`) head.textContent = `${first}–`;
      }
    }
    customElements.define('aq-results-count', AqResultsCount);
  }
  } catch(e) { console.error(e); }
})();

})();
